"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-console */
var react_1 = require("react");
var core_1 = require("@unform/core");
var styles_1 = require("./styles");
var InputMultiple = function (_a) {
    var name = _a.name, handleInputError = _a.handleInputError, icon = _a.icon, iconError = _a.iconError, messageErrorOnBlur = _a.messageErrorOnBlur, rest = __rest(_a, ["name", "handleInputError", "icon", "iconError", "messageErrorOnBlur"]);
    var inputRef = react_1.useRef(null);
    var _b = core_1.useField(name), fieldName = _b.fieldName, defaultValue = _b.defaultValue, registerField = _b.registerField, error = _b.error, clearError = _b.clearError;
    var _c = __read(react_1.useState(false), 2), success = _c[0], setSuccess = _c[1];
    var _d = __read(react_1.useState([]), 2), valueList = _d[0], setValueList = _d[1];
    react_1.useEffect(function () {
        // @ts-ignore
        registerField({
            name: fieldName,
            ref: inputRef.current,
            path: 'value',
            // @ts-ignore
            getValue: function (ref) {
                return valueList;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            setValue: function (ref, value) {
                ref.value = value;
                setValueList([]);
                setSuccess(false);
                clearError();
            },
        });
    }, [fieldName, registerField, clearError, valueList]);
    var handleBlur = react_1.useCallback(function (event) {
        if (!event.target.value) {
            if (!!handleInputError && !!messageErrorOnBlur) {
                handleInputError({
                    inputName: name,
                    message: messageErrorOnBlur,
                });
            }
        }
        else
            setSuccess(true);
    }, [handleInputError, messageErrorOnBlur, name]);
    var handleRemoveItem = react_1.useCallback(function (item) {
        setValueList(valueList.filter(function (data) { return data !== item; }));
    }, [valueList, setValueList]);
    var renderData = react_1.useCallback(function () {
        var show = [];
        var arr = [];
        valueList.map(function (item, index) {
            if (arr.length === 3) {
                show.push(arr);
                arr = [item];
                if (index === valueList.length - 1) {
                    show.push(arr);
                }
                return;
            }
            if (index === valueList.length - 1) {
                arr.push(item);
                show.push(arr);
                return;
            }
            arr.push(item);
        });
        return show;
    }, [valueList]);
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [valueList.length > 0 &&
                renderData().map(function (items, idx) { return (jsx_runtime_1.jsx(styles_1.Tags, { children: items.map(function (value) { return (jsx_runtime_1.jsxs("p", { children: [value, jsx_runtime_1.jsx("span", __assign({ onClick: function () { return handleRemoveItem(value); } }, { children: "X" }), void 0)] }, value)); }) }, Math.random() * 20)); }),
            jsx_runtime_1.jsxs(styles_1.Container, __assign({ error: !!error, success: success }, { children: [jsx_runtime_1.jsxs("div", __assign({ className: "input-wrapper" }, { children: [jsx_runtime_1.jsx("input", __assign({ name: name, ref: inputRef, defaultValue: defaultValue, onBlur: handleBlur, onFocus: function () {
                                    clearError();
                                    setSuccess(false);
                                }, onKeyPress: function (evt) {
                                    if (evt.key === 'Enter') {
                                        evt.preventDefault();
                                        if (evt.target.value !== '') {
                                            setValueList(__spread(valueList, [evt.target.value]));
                                            evt.target.value = '';
                                        }
                                    }
                                    clearError();
                                } }, rest), void 0),
                            !!icon && (jsx_runtime_1.jsx("div", __assign({ className: "icon" }, { children: jsx_runtime_1.jsx("img", { src: error ? iconError || icon : icon, alt: name }, void 0) }), void 0))] }), void 0),
                    !!error && messageErrorOnBlur && (jsx_runtime_1.jsx("div", __assign({ className: "error" }, { children: jsx_runtime_1.jsx("p", { children: error }, void 0) }), void 0))] }), void 0)] }, void 0));
};
exports.default = InputMultiple;
//# sourceMappingURL=index.js.map